export default __webpack_public_path__ + "static/media/pavlova.e8f303a7.png";